export enum IntegrationType {
  ENBOX = 'ENBOX',
  NEVERBOUNCE = 'NEVERBOUNCE',
  QC_MESSAGE_APP = 'QC_MESSAGE_APP',
  APIFON_VIBER_SMS = 'APIFON_VIBER_SMS',
  APIFON_SMS = 'APIFON_SMS',
  AWS_SES = 'AWS_SES',
  ELIQUA_CX = 'ELIQUA_CX',
  MSTAT_VIBER_SMS_V2 = 'MSTAT_VIBER_SMS_V2',
}

export interface LanguageModel {
  languageId: number;
  languageName: string;
  languageCode: string;
}
